import { render } from "./ProprietarioRead.vue?vue&type=template&id=120f4105&scoped=true"
import script from "./ProprietarioRead.vue?vue&type=script&lang=js"
export * from "./ProprietarioRead.vue?vue&type=script&lang=js"

import "./ProprietarioRead.vue?vue&type=style&index=0&id=120f4105&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120f4105"]])

export default __exports__